<template>
    <div>
        <div v-if="!clickedEditarEndereco">
            <!-- <p>{{ this.$store.state.deliveryEndereco }}</p> -->
            <!-- card entrega -->
            <div v-if="!retirarNoLocal && aceitaEntrega">
                <div class="texto-entrega-retirada">
                    <p>Olá <b>{{ this.nome }}.</b></p>
                    <p>Por favor, confirme o endereço de entrega.</p>
                    <!-- <p>{{ this.$store.state.deliveryTaxas }}</p> -->
                    <!-- <p>{{ this.$store.state.deliveryEndereco }}</p> -->
                </div>
                <!-- <p>{{ this.$store.state.deliveryEndereco }}</p> -->
                <!-- <p>{{ JSON.stringify(this.enderecos) }}</p> -->
                <!-- <p>{{ JSON.stringify(this.taxas) }}</p> -->
                <!-- @click="selecionarEsteEndereco(endereco) -->
                <div v-for="(endereco,index) in this.enderecos" :key="index">
                    <CardEndereco :endereco="endereco" :taxa="taxaParaBairro(endereco.bairro)" :retirarNoLocal=false :tempoEstimadoEntrega="tempoCadaEnd(taxaParaBairro(endereco.bairro))" :selecionado="enderecoSelecionadoParaEntrega.id==endereco.id" @onClickEditar="editarEndereco(endereco)" @onClickSelecionar="selecionarEsteEndereco(endereco)" @onClickDeletar="deletarEndereco(endereco)"/>
                </div>
                <div class="botoes-mudanca-entrega">
                    <button v-if="aceitaRetirada" type="" @click="selecionarEntrega(true)" class="btn-entrega">Retirar no local</button>
                    <button type="" @click="pedirEndereco" class="btn-entrega">Novo endereço</button>
                </div>
            </div>

            <!-- card retirar  -->
            <div v-if="retirarNoLocal && aceitaRetirada">
                <div class="texto-entrega-retirada">
                    <p>Olá <b>{{ this.nome }}.</b></p>
                    <p>Aqui está o endereço para retirada do seu pedido.</p>
                </div>
                <div :class="'card-retirar-entrega'" >
                    <div style="flex: 1;">
                        <CardEndereco :endereco="enderecoDaEmpresa" :retirarNoLocal=true :tempoEstimadoEntrega="tempoEntrega().retirada" :selecionado="true"/>
                    </div>
                </div>
                <p v-if="aceitaEntrega" class="texto-entrega-retirada">Deseja receber o pedido em seu endereço?</p>
                <div v-if="aceitaEntrega" class="botoes-mudanca-entrega">
                    <button type="" @click="mudarParaEntregaCasoTenhaEnd" class="btn-entrega">Entrega</button>
                </div>
            </div>
        </div>

        <p v-if="!aceitaRetirada&&!aceitaEntrega">Estamos com problemas técnicos.</p>
        
        <div v-if="clickedEditarEndereco" style="color: white">
            <DadosEndereco :exigirNome="false" :usarEnderecoAntigo="true" @enderecoAtualizado="enderecoAtualizado"/> 
        </div>

    
    </div>
</template>

<script>
import ApiDelivery from '@/api/ApisDelivery';
import CardEndereco from './CardEndereco.vue';
import DadosEndereco from './DadosEndereco.vue';
import Swal from "sweetalert2"

// import EnderecoModel from '@/model/enderecoModel'
export default {
    name: "ControleEnderecos",
    props: {
        enderecos: Array,
        nome:String,
    },
    components: { CardEndereco, DadosEndereco },
    data() {
        return ({
            clickedEditarEndereco: false,
            aceitaRetirada:this.$store.state.deliveryAceitaRetirada,
            aceitaEntrega:this.$store.state.deliveryAceitaEntrega,
            retirarNoLocal:this.$store.state.deliveryRetirarNoLocal,
            enderecoDaEmpresa:{
                rua:this.$store.state.endereco.rua,
                numero:this.$store.state.endereco.numero,
                bairro:this.$store.state.endereco.bairro,
                cidade:this.$store.state.endereco.cidade,
                uf:this.$store.state.endereco.uf,
            },
            tempo: new Date()
        });
    },
    computed: {
        enderecoSelecionadoParaEntrega(){
            return this.$store.state.deliveryEndereco;
        }
    },
    methods: {
        async deletarEndereco(endereco){
            console.log("Deletando endereço:");
            console.log(endereco);
            if(this.enderecos.length <= 1){
                Swal.fire({
                    icon: 'warning',
                    title: 'Atenção',
                    text: 'Você pode editar o endereço atual para mudar os dados, mas não pode deletar o único endereço cadastrado.',
                    confirmButtonText: 'Entendi'
                })
                return
            }
            else{
                Swal.fire({
                    title: "Tem certeza que deseja deletar esse endereço?",
                    text: endereco.rua + ', ' + endereco.numero + ' - ' + endereco.bairro,
                    // icon: 'warning',
                    imageUrl: require('../../assets/icons/ic-trash.png'),
                    showCancelButton: true,
                    confirmButtonText: 'Deletar!',
                    cancelButtonText: 'Cancelar'
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        await ApiDelivery.deletarEndereco(endereco.id);
                        let enderecosAtualizados = this.enderecos.filter(e => e.id !== endereco.id)
                        this.$emit("enderecosAtualizados", enderecosAtualizados)
                        this.selecionarEsteEndereco(enderecosAtualizados[0])
                        Swal.fire(
                            'Deletado!',
                            'O endereço foi deletado.',
                            'success'
                        )
                    }
                })
            }
        },
        tempoCadaEnd(taxa){
            if (!taxa || taxa.TempoMedioEntrega == null) return null
            const itemMaisDemorado = Number(this.$store.state.dhPrevisaoEntregaAteAgora) || 0
            return Number(taxa.TempoMedioEntrega) + itemMaisDemorado
        },
        taxaParaBairro(bairroEndereco) {
            let todasAsTaxas = this.$store.state.deliveryTaxasDeTodosEnderecos
            let taxaEncontrada = todasAsTaxas.find(t => t.Nome === bairroEndereco)
            return taxaEncontrada || null
        },
        selecionarEsteEndereco(endereco){
            this.$store.dispatch("setDeliveryEndereco", endereco)
            this.$store.dispatch("setDeliveryTaxas", this.taxaParaBairro(endereco.bairro))
            console.log("Endereço selecionado para entrega:");
            console.log(endereco);
        },
        aumentarTempo() {
            let novotempo = new Date(this.tempo)
            novotempo.setMinutes(novotempo.getMinutes() + 10)
            this.tempo = novotempo
        },

        editarEndereco(endereco) {
            this.selecionarEsteEndereco(endereco)
            this.$router.push({ path: "/deliveryendereco",query: { novo:false, telefone: this.telefone }})
            this.clickedEditarEndereco = true
        },
        pedirEndereco() {
            this.$router.push({ path: "/deliveryendereco",query: { novo:true, telefone: this.telefone }})
            this.clickedEditarEndereco = true
        },
        mudarParaEntregaCasoTenhaEnd() {
            if(this.enderecoSelecionadoParaEntrega){
                console.log("Vamos ver aqui os itens selecionados")
                console.log(this.enderecoSelecionadoParaEntrega)
                this.selecionarEntrega(false)
            }
            else
                this.pedirEndereco()
        },

        enderecoAtualizado() {
            this.clickedEditarEndereco = false
        },

        selecionarEntrega(selecionouRetirarNoLocal) {
            this.retirarNoLocal = selecionouRetirarNoLocal
            this.enviarCallback()
            this.tempoEntrega()
        },

        tempoEntrega() {
            let tempoEntregaCalculado = {}
            let carrinho = this.$store.state.itensCarrinho
            let maxValueEntrega = 0.0
            console.log("items")
            console.log(carrinho.length)
            carrinho.forEach(e => {
                console.log("item auqi")
                console.log(e.tempoEstimado)
                if (Number(e.tempoEstimado) > maxValueEntrega) {
                    maxValueEntrega = Number(e.tempoEstimado)
                }
            })
            let retirarNoLocal = this.$store.state.deliveryRetirarNoLocal
            let taxasAqui = retirarNoLocal ? null : this.$store.state.deliveryTaxas

            let dataAgora = new Date()
            let dataAgora2 = new Date()

            const itemMaisDemorado = Number(this.$store.state.dhPrevisaoEntregaAteAgora)

            const  dataHoraRetirada = dataAgora.setMinutes(dataAgora.getMinutes() + itemMaisDemorado)
            const  dataHoraEntrega = dataAgora2.setMinutes(dataAgora2.getMinutes() + (taxasAqui?.TempoMedioEntrega  + itemMaisDemorado))


            tempoEntregaCalculado.itemMaisDemorado =itemMaisDemorado
            tempoEntregaCalculado.retirada = itemMaisDemorado
            tempoEntregaCalculado.retiradaDh = dataHoraRetirada.toString()
            tempoEntregaCalculado.entrega = taxasAqui?.TempoMedioEntrega  + itemMaisDemorado
            tempoEntregaCalculado.entregaDh = dataHoraEntrega.toString()
            // tempoEntregaCalculado.itemMaisDemorado = this.$store.state.dhPrevisaoEntregaAteAgora
            // tempoEntregaCalculado.retirada = maxValueEntrega
            // tempoEntregaCalculado.retiradaDh = dataAgora.setMinutes(dataAgora.getMinutes() + maxValueEntrega).toString()
            // tempoEntregaCalculado.entrega = taxasAqui.TempoMedioEntrega  + maxValueEntrega
            // tempoEntregaCalculado.entregaDh = dataAgora2.setMinutes(dataAgora2.getMinutes() + (taxasAqui.TempoMedioEntrega  + maxValueEntrega)).toString()

            console.log("calculando tempo de entrega")
            console.log(tempoEntregaCalculado)

            if (retirarNoLocal) {
                this.$store.dispatch("setDeliveryDhPrevisaoEntrega", tempoEntregaCalculado.retirada);
            } else {
                this.$store.dispatch("setDeliveryDhPrevisaoEntrega", tempoEntregaCalculado.entrega);
            }

            return tempoEntregaCalculado
        },

        enviarCallback() {
            this.$emit("callback", {retirarNoLocal: this.retirarNoLocal})
        },

       

    }
}
</script>

<style scoped>

img { height: 35px}

.opcaoss  {display: flex; align-items: center;  width: 100%;}
.opcaoss > div { display: block; width: 100%;}

.endereco-retirar-no-local { margin-block: 7px; font-size: 0.8rem; width: 100%;text-align: start;padding: 10px;}

.texto-entrega-retirada{
    padding-inline: 5px;
    margin-top: 10px;
    text-align: start;
}
 
.btn-entrega {
    background: var(--gradiente-escuro);
    min-height: 50px;
    color: var(--cor-texto);
    padding: 10px;
    padding-inline: 10px;
    flex: 1;
    border-radius: 4px;
}
.botoes-mudanca-entrega{
    display: flex;
    justify-content: center;
    margin-top: var(--padding-padrao);
    gap: var(--padding-padrao);
}
</style>
